// Users Action Types

export const GET_USERS_LIST_START = "GET_USERS_LIST_START";
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS";
export const GET_USERS_LIST_FAILURE = "GET_USERS_LIST_FAILURE";

export const UPLOAD_CONTENTS_LIST_START = "UPLOAD_CONTENTS_LIST_START";
export const UPLOAD_LABELS_LIST_START = "UPLOAD_LABELS_LIST_START";
export const UPLOAD_LABELS_LIST_SUCCESS = "UPLOAD_LABELS_LIST_SUCCESS";
export const UPLOAD_LABELS_LIST_FAILURE = "UPLOAD_LABELS_LIST_FAILURE";

export const GET_LABELS_LIST_START = "GET_LABELS_LIST_START";
export const GET_LABELS_LIST_SUCCESS = "GET_LABELS_LIST_SUCCESS";
export const GET_LABELS_LIST_FAILURE = "GET_LABELS_LIST_FAILURE";

export const GET_LABELS_SERVICE_LIST_START = "GET_LABELS_SERVICE_LIST_START";
export const GET_LABELS_SERVICE_LIST_SUCCESS = "GET_LABELS_SERVICE_LIST_SUCCESS";
export const GET_LABELS_SERVICE_LIST_FAILURE = "GET_SERVICE_LABELS_LIST_FAILURE";

export const GET_PARENT_LABELS_LIST_START = "GET_PARENT_LABELS_LIST_START";
export const GET_PARENT_LABELS_SUCCESS = "GET_PARENT_LABELS_LIST_SUCCESS";
export const GET_PARENT_LABELS_FAILURE = "GET_PARENT_LABELS_FAILURE";

export const GET_PARENT_LABEL_DATA_START = "GET_PARENT_LABEL_DATA_START";
export const GET_PARENT_LABEL_DATA_SUCCESS = "GET_PARENT_LABEL_DATA_SUCCESS";
export const GET_PARENT_LABEL_DATA_FAILURE = "GET_PARENT_LABEL_DATA_FAILURE";

export const ADD_NEW_LABEL_START = "ADD_NEW_LABEL_START";
export const ADD_NEW_LABEL_SERVICE_START = "ADD_NEW_LABEL_SERVICE_START";
export const EDIT_LABEL_SERVICE_START = "EDIT_LABEL_SERVICE_START";
export const ADD_NEW_PARENT_LABEL_START = "ADD_NEW_PARENT_LABEL_START";
export const ADD_NEW_LABEL_SUCCESS = "ADD_NEW_LABEL_SUCCESS";
export const ADD_NEW_LABEL_FAILURE = "ADD_NEW_LABEL_FAILURE";

export const ACTIVE_lABEL_SERVICE = "ACTIVE_lABEL_SERVICE";


export const LICENSE_LABEL_START = "LICENSE_LABEL_START";
export const LICENSE_LABEL_SUCCESS = "LICENSE_LABEL_SUCCESS";
export const LICENSE_LABEL_FAILURE = "LICENSE_LABEL_FAILURE";

export const LABELS_MESSAGE_HANDLER = "LABELS_MESSAGE_HANDLER";

export const GET_REFERENCES_LIST_START = "GET_REFERENCES_LIST_START";
export const GET_REFERENCES_LIST_SUCCESS = "GET_REFERENCES_LIST_SUCCESS";
export const GET_REFERENCES_LIST_FAILURE = "GET_REFERENCES_LIST_FAILURE";

export const ADD_NEW_REFERENCE_START = "ADD_NEW_REFERENCE_START";
export const ADD_NEW_REFERENCE_SUCCESS = "ADD_NEW_REFERENCE_SUCCESS";
export const ADD_NEW_REFERENCE_FAILURE = "ADD_NEW_REFERENCE_FAILURE";

export const EDIT_REFERENCE = "EDIT_REFERENCE";

export const REFERENCE_MESSAGE_HANDLER = "REFERENCE_MESSAGE_HANDLER";

export const ACTIVE_CP_MANAGER = "ACTIVE_CP_MANAGER";

export const UPLOAD_CP_MANAGERS_LIST_START = "UPLOAD_CP_MANAGERS_LIST_START";
export const GET_CP_MANAGERS_LIST_START = "GET_CP_MANAGERS_LIST_START";
export const GET_CP_MANAGERS_LIST_SUCCESS = "GET_CP_MANAGERS_LIST_SUCCESS";
export const GET_CP_MANAGERS_LIST_FAILURE = "GET_CP_MANAGERS_LIST_FAILURE";

export const GET_CP_CONTRACT_LIST_START = "GET_CP_CONTRACT_LIST_START";
export const GET_CP_CONTRACT_LIST_SUCCESS = "GET_CP_CONTRACT_LIST_SUCCESS";
export const GET_CP_CONTRACT_LIST_FAILURE = "GET_CP_CONTRACT_LIST_FAILURE";

export const ADD_CONTRACT_START = "ADD_CONTRACT_START";
export const ADD_CONTRACT_SUCCESS = "ADD_CONTRACT_SUCCESS";
export const ADD_CONTRACT_FAILURE = "ADD_CONTRACT_FAILURE";

export const GET_CP_SERVICES_LIST_START = "GET_CP_SERVICES_LIST_START";
export const GET_CP_SERVICES_LIST_SUCCESS = "GET_CP_SERVICES_LIST_SUCCESS";
export const GET_CP_SERVICES_LIST_FAILURE = "GET_CP_SERVICES_LIST_FAILURE";

export const ADD_CP_SERVICE_START = "ADD_CP_SERVICE_START";
export const ADD_CP_SERVICE_SUCCESS = "ADD_CP_SERVICE_SUCCESS";
export const ADD_CP_SERVICE_FAILURE = "ADD_CP_SERVICE_FAILURE";


export const GET_SERVICES_LIST_START = "GET_SERVICES_LIST_START";
export const GET_SERVICES_LIST_SUCCESS = "GET_SERVICES_LIST_SUCCESS";
export const GET_SERVICES_LIST_FAILURE = "GET_SERVICES_LIST_FAILURE";
export const GET_SERVICES_DATA_START = "GET_SERVICES_DATA_START";
export const GET_SERVICES_DATA_SUCCESS = "GET_SERVICES_DATA_SUCCESS";
export const GET_SERVICES_DATA_FAILURE = "GET_SERVICES_DATA_FAILURE";
export const SERVICE_MESSAGE_HANDLER = "SERVICE_MESSAGE_HANDLER";

export const GET_SERVICE_REPORT_START = "GET_SERVICE_REPORT_START";
export const GET_SERVICE_REPORT_SUCCESS = "GET_SERVICE_REPORT_SUCCESS";
export const GET_SERVICE_REPORT_FAILURE = "GET_SERVICE_REPORT_FAILURE";

export const GET_LABEL_SERVICE_REPORT_START = "GET_LABEL_SERVICE_REPORT_START";
export const GET_LABEL_SERVICE_REPORT_SUCCESS = "GET_LABEL_SERVICE_REPORT_SUCCESS";
export const GET_LABEL_SERVICE_REPORT_FAILURE = "GET_LABEL_SERVICE_REPORT_FAILURE";

export const GET_CONTENT_LIST_START = "GET_CONTENT_LIST_START";
export const GET_CONTENT_LIST_SUCCESS = "GET_CONTENT_LIST_SUCCESS";
export const GET_CONTENT_LIST_FAILURE = "GET_CONTENT_LIST_FAILURE";

export const ADD_CONTENT_START = "ADD_CONTENT_START";
export const ADD_CONTENT_SUCCESS = "ADD_CONTENT_SUCCESS";
export const ADD_CONTENT_FAILURE = "ADD_CONTENT_FAILURE";
export const Edit_CONTENT = "Edit_CONTENT";

export const GET_CONTENT_MESSAGE_HANDLER = "GET_CONTENT_MESSAGE_HANDLER";

export const GET_LICENSED_TERRITORIES_LIST_START = "GET_LICENSED_TERRITORIES_LIST_START";
export const GET_LICENSED_TERRITORIES_LIST_SUCCESS = "GET_LICENSED_TERRITORIES_LIST_SUCCESS";
export const GET_LICENSED_TERRITORIES_LIST_FAILURE = "GET_LICENSED_TERRITORIES_LIST_FAILURE";

export const GET_TERRITORIES_LIST_START = "GET_TERRITORIES_LIST_START";
export const GET_TERRITORIES_LIST_SUCCESS = "GET_TERRITORIES_LIST_SUCCESS";
export const GET_TERRITORIES_LIST_FAILURE = "GET_TERRITORIES_LIST_FAILURE";

export const ADD_TERRITORY_START = "ADD_TERRITORY_START";
export const DELETE_TERRITORY_START = "DELETE_TERRITORY_START";
export const ADD_TERRITORY_SUCCESS = "ADD_TERRITORY_SUCCESS";
export const ADD_TERRITORY_FAILURE = "ADD_TERRITORY_FAILURE";

export const TERRITORY_MESSAGE_HANDLER = "TERRITORY_MESSAGE_HANDLER";

export const GET_CONTENT_REPORT_START = "GET_CONTENT_REPORT_START";
export const GET_CONTENT_REPORT_SUCCESS = "GET_CONTENT_REPORT_SUCCESS";
export const GET_CONTENT_REPORT_FAILURE = "GET_CONTENT_REPORT_FAILURE";
export const SET_LOADING = "SET_LOADING";
export const SERVICE_REPORT_MESSAGE_HANDLER = "SERVICE_REPORT_MESSAGE_HANDLER";

export const GENERATE_REPORT_START = "GENERATE_REPORT_START";
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS";
export const GENERATE_REPORT_FAILURE = "GENERATE_REPORT_FAILURE";

export const SET_USER_SERVICES_LIST = "USER_SERVICES_LIST";
export const SET_CATEGORY_LIST = "SET_CATEGORY_LIST";

// export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
// export const GET_USER_DATA_FAILURE = "GET_USER_DATA_ERROR";

export const GET_USER_DATA_START = "GET_USER_DATA_START";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILURE = "GET_USER_DATA_ERROR";

export const MESSAGE_HANDLER = "MESSAGE_HANDLER";
export const CP_SERVICE_MESSAGE_HANDLER = "CP_SERVICE_MESSAGE_HANDLER";
export const CP_MESSAGE_HANDLER = "CP_MESSAGE_HANDLER";

export const ADD_NEW_USER_START = "ADD_NEW_USER_START";
export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS";
export const ADD_NEW_USER_FAILURE = "ADD_NEW_USER_FAILURE";

export const EDIT_CP = "EDIT_CP";
export const ADD_NEW_CP_START = "ADD_NEW_CP_START";
export const ADD_NEW_CP_SUCCESS = "ADD_NEW_CP_SUCCESS";
export const ADD_NEW_CP_FAILURE = "ADD_NEW_CP_FAILURE";

export const GET_CP_START = "GET_CP_START";
export const GET_CP_SUCCESS = "GET_CP_SUCCESS";
export const GET_CP_FAILURE = "GET_CP_FAILURE";

export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const GET_EMPLOYEE_DATA_START = "GET_EMPLOYEE_DATA_START";
export const GET_EMPLOYEE_DATA_SUCCESS = "GET_EMPLOYEE_DATA_SUCCESS";
export const GET_EMPLOYEE_DATA_ERROR = "GET_EMPLOYEE_DATA_ERROR";

export const SIGNUP_START = "SIGNUP_START";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGIN_ERROR_HANDLER_SUCCESS = "LOGIN_ERROR_HANDLER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";


export const DASHBOARD_START = "DASHBOARD_START";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_FAILURE = "DASHBOARD_FAILURE";
export const DASHBOARD_ERROR_HANDLER_SUCCESS = "DASHBOARD_ERROR_HANDLER_SUCCESS";

export const CONFIRMATION_MODAL = "CONFIRMATION_MODAL";
export const HELP_HANDLER = "HELP_HANDLER";

export const GET_INVOICES_LIST_START = "GET_INVOICES_LIST_START";
export const GET_INVOICES_LIST_SUCCESS = "GET_INVOICES_LIST_SUCCESS";
export const GET_INVOICES_LIST_FAILURE = "GET_INVOICES_LIST_FAILURE";

export const GET_LABEL_INVOICES_LIST_START = "GET_LABEL_INVOICES_LIST_START";
export const GET_LABEL_INVOICES_LIST_SUCCESS = "GET_LABEL_INVOICES_LIST_SUCCESS";
export const GET_LABEL_INVOICES_LIST_FAILURE = "GET_LABEL_INVOICES_LIST_FAILURE";

export const GET_INVOICES_REPORT_LIST_START = "GET_INVOICES_REPORT_LIST_START";
export const GET_INVOICES_REPORT_LIST_SUCCESS = "GET_INVOICES_REPORT_LIST_SUCCESS";
export const GET_INVOICES_REPORT_LIST_FAILURE = "GET_INVOICES_REPORT_LIST_FAILURE";
export const REJECTED_INVOICES_HANDLER = "REJECTED_INVOICES_HANDLER";
export const INVOICES_ERROR_HANDLER = "INVOICES_ERROR_HANDLER";

export const UPDATE_INVOICE_START = "UPDATE_INVOICE_START";
export const GENERATE_INVOICE_START = "GENERATE_INVOICE_START";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";
export const GENERATE_INVOICE_FAILURE = "GENERATE_INVOICE_FAILURE";



export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";


export const VERIFY_PASSWORD_START = "VERIFY_PASSWORD_START";
export const VERIFY_PASSWORD_SUCCESS = "VERIFY_PASSWORD_SUCCESS";
export const VERIFY_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

export const CLEAR_REPORT_LOGS_START = "CLEAR_REPORT_LOGS_START";
export const CLEAR_REPORT_LOGS_SUCCESS = "CLEAR_REPORT_LOGS_SUCCESS";
export const CLEAR_REPORT_LOGS_FAILURE = "CLEAR_REPORT_LOGS_FAILURE";

